




























import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import WlAvatar from '@/components/Commons/WlAvatar.vue';
import LikeSolid from '@/components/SvgIcons/LikeSolid.vue';
@Component({
  components: {
    WlAvatar,
    LikeSolid,
  },
})
export default class PostLikeList extends Vue {
  @Prop() upCount;
  @Prop() postId;
  @Prop() hasLiked;
  get likeList() {
    return 'like-list-' + this.postId;
  }

  get userList() {
    return vxm.forum.LikeUserList;
  }

  fetchPostLikesUserList() {
    return vxm.forum.fetchLikeList(this.postId);
  }
  
  get svgClass() {
     return this.hasLiked ? 'svg-circle bg-primary-light' : '';             
  }
}
